import { useConnectModal } from "@rainbow-me/rainbowkit";
import React from "react";
import { useAccount } from "wagmi";
import SimpleButton from "../SimpleButton";

type Props = {
  children?: React.ReactNode;
};

export default function ConnectGuard(props: Props) {
  const { address, isConnected } = useAccount();
  return (
    <div className="w-full">
      {isConnected ? props.children : <ConnectButton />}
    </div>
  );
}

const ConnectButton: React.FC<{ smol?: boolean }> = ({ smol }) => {
  const { openConnectModal } = useConnectModal();
  return (
    <>
      <SimpleButton
        color="bg-primary"
        className="w-full text-black py-3 "
        onClick={() => openConnectModal && openConnectModal()}
      >
        Connect
      </SimpleButton>
    </>
  );
};
